import Vue from 'vue';
import VueRouter from 'vue-router';
import charts from './charts';
import income from './income';
import account from './account';
import { $vi18n } from '@/utils/i18n.js';
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);

// $vi18n('$i18n# 固定路由 #i18n$')
export const constantRoutes = () => [
  // $vi18n('$i18n# 首页 #i18n$')
  {
    path: '/',
    redirect: '/home',
    component: () => import('@/layout/index.vue'),
    meta: {
      title: $vi18n('$i18n# 首页 #i18n$'),
      icon: 'icon-home',
      activePath: 'home',
    },
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
      },
      // {
      //   path: 'userTransferPage',
      //   name: 'UserTransferPage',
      //   component: () => import('@/components/UserTransferPage.vue'),
      // },
    ],
  },
  {
    path: '/userTransferPage',
    component: () => import('@/layout/index.vue'),
    hidden: true,
    children: [
      {
        path: '',
        name: 'UserTransferPage',
        component: () => import('@/components/UserTransferPage.vue'),
      },
    ],
  },

  {
    path: '/login',
    name: 'Login',
    component:  () => import('@/views/Login.vue'),
    hidden: true,
  },
  {
    path: '/Certify/:uin',
    name: 'Certify',
    component: () => import('@/views/Certify.vue'),
    hidden: true,
  },
  // $vi18n('$i18n# 数据中心 #i18n$')
  ...charts,
  // $vi18n('$i18n# 收益管理 #i18n$')
  ...income,
  //$vi18n('$i18n# 活动赛事 #i18n$')
  // ...activity,

  //$vi18n('$i18n# 创作灵感 #i18n$')
  // ...creation,

  // $vi18n('$i18n# 云服 #i18n$')
  // ...cloudServer, // TODO $vi18n('$i18n# 临时注释 #i18n$')
  // $vi18n('$i18n# 兑换商城 #i18n$')
  // ...exchangeShop,
  // $vi18n('$i18n# 活动配置 #i18n$')
  // ...actConf,
  // $vi18n('$i18n# 账号管理 #i18n$')
  ...account,
  // $vi18n('$i18n# 工作室 #i18n$')
  // ...studio,
  // 404
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/account/overseas/registry.vue'),
    meta: {
      title: $vi18n('$i18n# 账号注册 #i18n$'),
    },
    hidden: true
  },
  {
    path: '/examination',
    name: 'examination',
    component: () => import('@/views/examination/index.vue'),
    meta: {
      title: $vi18n('$i18n# 答题 #i18n$'),
    },
    hidden: true
  },
  {
    path: '/404',
    component: () => import('../views/404'),
    hidden: true,
  },
  // { path: '*', redirect: '/404', hidden: true },
];

// $vi18n('$i18n# 动态路由 #i18n$') - $vi18n('$i18n# 目前的缺点 #i18n$')：$vi18n('$i18n# 只控制了大模块 #i18n$')，$vi18n('$i18n# 没有控制细分的子孙路由 #i18n$')
export const asyncRoutes = [...income];
// export const asyncRoutes4Manager = [...studioManager];
// export const asyncRoutes4Member = [...studioMember];
// export const asyncRoutes4VipManager = [...studioVipManager];
// export const asyncRoutes4VipMember = [...studioVipMember];
// export const asyncRoutes4Creator = [...studioCreator];
// TODO $vi18n('$i18n# 临时代码 #i18n$')
// export const asyncCloudRoutes = [...cloudServer];
// export const asyncCloudRoutesNameList = ['cloudserver'];
// export const asyncActConfRoutes = [...actConf];
// export const asyncActConfRoutesNameList = ['actConf'];

// $vi18n('$i18n# 动态路由名单 #i18n$')
export const asyncRouteNameList = ['Income'];
// export const asyncRoute4ManagerNameList = ['StudioManager'];
// export const asyncRoute4MemberNameList = ['StudioMember'];
// export const asyncRoute4VipMemberNameList = ['StudioVipMember'];
// export const asyncRoute4VipManagerNameList = ['StudioVipManager'];
// export const asyncRoute4CreatorNameList = ['StudioCreator'];

// $vi18n('$i18n# 公共路由 #i18n$')
export const publicRoutes = [{ path: '*', redirect: '/404', hidden: true }];

const createRouter = () =>
  new VueRouter({
    routes: constantRoutes(),
    scrollBehavior: () => ({ y: 0 }),
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export function getRouter () {
  return router
}

export default router;

